import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../../store'

// mininapp router
import MiniApp from '../pages/miniapp/Main.vue'
import AppHome from '../components/Home.vue'

import MiniAppHome from '../pages/miniapp/Home.vue'
import MiniAppOnboarding from '../pages/miniapp/Onboarding.vue'
import MiniAppIndicesQuote from '../pages/miniapp/indices/Quote.vue'
import MiniAppStockQuote from '../pages/miniapp/stock/Quote.vue'
import MiniAppWatchList from '../pages/miniapp/WatchList.vue'
import MiniAppSearch from '../pages/miniapp/Search.vue'
import MiniAppLtfRmf from '../pages/miniapp/LtfRmf.vue'
import MiniAppTermsAndConditions from '../pages/miniapp/TermsAndConditions.vue'
import MiniAppTradingview from '../pages/miniapp/Tradingview.vue' // router
import MiniAppStockChart from '../pages/miniapp/StockChart.vue' // router
import MiniAppSetting from '../pages/miniapp/Setting.vue'
import MiniAppAssets from '../pages/miniapp/setting/Assets.vue'

import RouterMarket from './market'
import RouterFund from './fund'
import RouterPlan from './plan'

import Login from '../components/Login.vue'
import Callback from '../components/Callback.vue'
import SplashScreen from '../components/SplashScreen.vue'

import NotFound from '../components/errors/NotFound.vue'
import InteralServerError from '../components/errors/InteralServerError.vue'
import ServiceUnavailable from '../components/errors/ServiceUnavailable.vue'

import PortIntro from '../components/landing/PortIntro.vue'
import AppIntro from '../components/landing/AppIntro.vue'
import AppDownload from '../components/landing/AppDownload.vue'


Vue.use(VueRouter)

const arrY = []

const scrollBehavior = (to, from, savedPosition) => new Promise((resolve) => {
  if (arrY && arrY.length > 0) {
    let findArrY = arrY.find(function (ele) {
      return ele.name === from.name;
    });
    if (findArrY) {

      findArrY.scroll = to.params.scroll
    } else {
      arrY.push({
        name: from.name,
        scroll: to.params.scroll
      })
    }
  } else {
    arrY.push({
      name: from.name,
      scroll: to.params.scroll
    })
  }

  const findPositionY = arrY.find(function (ele) {
    return ele.name === to.name;
  });

  if (findPositionY) {
    const position = savedPosition || { x: 0, y: parseInt(findPositionY.scroll) } // map scroll

    Router.app.$root.$once('triggerScroll', () => {
      Router.app.$nextTick(() => resolve(position));
    });
  }
})

const initLiff = (liffId) => {
  return new Promise((resolve, reject) => {
    window.liff.init(
      { liffId: liffId },
      () => {
        window.liff.ready.then(() => {
          window.liff
            .getProfile()
            .then(profile => {
              resolve(profile.userId)
            })
            .catch(err => {
              reject(err)
            })
        })
      },
      err => {
        reject(err)
      }
    )
  })
}


const Router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior,
  routes: [

    {
      path: '/',
      name: 'app',
      component: SplashScreen,
      props: true,
    },
    // for get access token
    {
      path: '/home',
      name: 'home',
      component: AppHome,
      props: true,
    },
    {
      path: '/miniapp',
      name: 'miniapp',
      component: MiniApp,
      redirect: { name: 'miniapp-home' },
      props: true,
      children: [
        {
          path: 'home',
          name: 'miniapp-home',
          component: MiniAppHome,
          props: true,
        },
        {
          path: 'onboarding',
          name: 'miniapp-onboarding',
          component: MiniAppOnboarding,
          props: true
        },
        RouterMarket,
        RouterFund,
        {
          path: 'stock',
          name: 'miniapp-stock-quote',
          component: MiniAppStockQuote,
          props: true,
        },
        {
          path: 'indices',
          name: 'miniapp-indices-quote',
          component: MiniAppIndicesQuote,
          props: true,
        },
        {
          path: 'watch-list',
          name: 'miniapp-watch-list',
          component: MiniAppWatchList,
          props: true,
        },
        {
          path: 'search',
          name: 'miniapp-search',
          component: MiniAppSearch,
          props: true,
        },
        {
          path: 'ltf-rmf',
          name: 'miniapp-ltf-rmf',
          component: MiniAppLtfRmf,
          props: true,
        },
        {
          path: 'setting',
          name: 'miniapp-setting',
          component: MiniAppSetting,
          props: true,
        },
        {
          path: 'assets',
          name: 'miniapp-assets',
          component: MiniAppAssets,
          props: true,
        },
        {
          path: 'terms-and-conditions',
          name: 'miniapp-terms-and-conditions',
          component: MiniAppTermsAndConditions,
          props: true,
        },
        {
          path: 'tradingview',
          name: 'miniapp-tradingview',
          component: MiniAppTradingview,
          props: true,
        },
        {
          path: 'stockchart',
          name: 'miniapp-stockchart',
          component: MiniAppStockChart,
          props: true,
        },
      ]
    },
    {
      path: '/port-intro',
      name: 'portintro',
      component: PortIntro,
      props: true,
    },
    {
      path: '/app-intro',
      name: 'appintro',
      component: AppIntro,
      props: true,
    },
    {
      path: '/download',
      name: 'download',
      component: AppDownload,
      props: true,
    },
    RouterPlan,
    {
      path: '/signin',
      name: 'signin',
      component: Login,
      props: true,
    },
    {
      path: '/return',
      name: 'return',
      component: Callback,
      props: true,
    },
    {
      path: '/404',
      name: '404',
      component: NotFound,
      props: true,
    },
    {
      path: '/500',
      name: '500',
      component: InteralServerError,
      props: true,
    },
    {
      path: '/503',
      name: '503',
      component: ServiceUnavailable,
      props: true,
    },
    { path: "*", component: NotFound }
  ]
})


Router.beforeEach(async (to, from, next) => {
  if (!store.state.onboarding.userConfiguration.lineid) {
    try {
      // get line ID
      if (to.query.mode && to.query.mode === 'qa_test') store.state.onboarding.userConfiguration.lineid = "qa_test"
      else store.state.onboarding.userConfiguration.lineid = await initLiff(process.env.VUE_APP_LIFF_ID)
      // fetch user and global config 
      await store.dispatch("onboarding/fetchConfiguration")
      await store.dispatch("onboarding/fetchGlobalConfiguration", "line-liff/config/onboarding.json")
      // check user and global config 
      to.name != 'miniapp-onboarding'
        ? store.getters['onboarding/getCompareOnboarding']
          ? to.name == 'miniapp'
            ? next({ name: 'miniapp-home' })
            : next()
          : next({ name: 'miniapp-onboarding' })
        : next()
    } catch (err) {
      to.name == 'miniapp' ? next({ name: 'miniapp-home' }) : next() // can not get line ID
      throw new Error(err)
    }
  } else next()
})

export default Router